import { Select, SelectItem } from "@/components/ui/select";
import { GetAllAssetInsightsReq } from "@/api/studio/insights/api";

/* Prop Types */
interface SelectSortReportsProps {
  currentTab: "creative" | "attention" | "memory" | "emotion";
  orderBy: GetAllAssetInsightsReq["orderBy"];
  sortBy: GetAllAssetInsightsReq["sortBy"];
  setOrderBy: (value: GetAllAssetInsightsReq["orderBy"]) => void;
  setSortBy: (value: GetAllAssetInsightsReq["sortBy"]) => void;
}

/*
 * SelectSortReports component
 *
 * Component to sort assets in report views.
 * Owns the combined logic of setting both orderBy and sortBy together.
 */
export const SelectSortReports = ({ currentTab, orderBy, sortBy, setOrderBy, setSortBy }: SelectSortReportsProps) => {
  /* Handlers */
  const handleOnChange = (value: string) => {
    switch (value) {
      case "desc":
        setOrderBy(currentTab);
        setSortBy("desc");
        break;
      case "asc":
        setOrderBy(currentTab);
        setSortBy("asc");
        break;
      case "nameAsc":
        setOrderBy("name");
        setSortBy("asc");
        break;
      case "nameDesc":
        setOrderBy("name");
        setSortBy("desc");
        break;
      default:
        break;
    }
  };

  const selectValue = orderBy === "name" ? (sortBy === "asc" ? "nameAsc" : "nameDesc") : (sortBy ?? "desc");

  /* Render */
  return (
    <Select onChange={handleOnChange} value={selectValue}>
      <SelectItem value="desc">Highest score</SelectItem>
      <SelectItem value="asc">Lowest score</SelectItem>
      <SelectItem value="nameAsc">Asset name A-Z</SelectItem>
      <SelectItem value="nameDesc">Asset name Z-A</SelectItem>
    </Select>
  );
};
